import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { InventoryReportTableParams } from 'utils/apiClient/services/reports/types';
import { useApiClient } from '../../utils/apiClient';

/* eslint-disable import/prefer-default-export */
export const useLoadInventoryReport = ({
  tableParams,
  enabled,
}: {
  tableParams: InventoryReportTableParams;
  enabled: boolean;
}) => {
  const apiClient = useApiClient();
  const keyParams = {
    ...tableParams,
    ...(tableParams.sorter !== undefined && {
      sorter: {
        //@ts-ignore
        columnKey: tableParams.sorter.columnKey,
        //@ts-ignore
        order: tableParams.sorter.order,
      },
    }),
  };
  return useQuery({
    queryKey: ['reports', 'inventory', keyParams],
    queryFn: () => apiClient.Reports.loadInventoryReport(keyParams),
    staleTime: 1500,
    refetchOnWindowFocus: true,
    placeholderData: keepPreviousData,
    enabled,
  });
};
